import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ServiceStatusResponse } from '../../types/velociraptor-settings'
import { StatusBadge } from './StatusBadge'

interface PageHeaderProps {
  status: ServiceStatusResponse | null
  isRunning: boolean
  onRefresh: () => void
}

export function PageHeader({ status, isRunning, onRefresh }: PageHeaderProps): React.ReactElement {
  const { t } = useTranslation('admin')
  const runningLabel = isRunning ? { label: t('velociraptorSettings.running') } : {}
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-stone-900 dark:text-stone-100">
          {t('velociraptorSettings.title')}
        </h1>
        <p className="mt-1 text-sm text-stone-600 dark:text-stone-400">
          {t('velociraptorSettings.description')}
        </p>
      </div>
      <div className="flex items-center gap-3">
        {status && <StatusBadge status={status.status} {...runningLabel} />}
        <button
          onClick={onRefresh}
          className="p-2 text-stone-500 hover:text-stone-700 dark:hover:text-stone-300"
        >
          <RefreshCw className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}
